/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureeventwithcover4Inputs */

const en_aifeatureeventwithcover4 = /** @type {(inputs: Aifeatureeventwithcover4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event with cover image`)
};

const de_aifeatureeventwithcover4 = /** @type {(inputs: Aifeatureeventwithcover4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung mit Titelbild`)
};

/**
* | output |
* | --- |
* | "Event with cover image" |
*
* @param {Aifeatureeventwithcover4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureeventwithcover4 = /** @type {((inputs?: Aifeatureeventwithcover4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureeventwithcover4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureeventwithcover4(inputs)
	return de_aifeatureeventwithcover4(inputs)
});
export { aifeatureeventwithcover4 as "aiFeatureEventWithCover" }